import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToSelf = {
  [titleId: string]: WpsTypes.atv.wps.SelfFragmentModelProps | undefined
}

export const reducer = createMergeReducer(t => t.self, {} as TitleIdToSelf)
